import React, { useContext, useEffect, useState } from "react";
import "./ComentariosElementos.css";
import { AuthContext } from "../../context/AuthContext";
import {
  deleteComentario,
  getComentarioById,
  getComentariosByElementoId,
  getComentariosByTareaId,
  postComentario,
  putComentario,
} from "../../api/comentariosElementos";
import { Grid, TextField, Typography } from "@mui/material";
import { insertarBotonesModal } from "../../helpers/insertarBotonesModal";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import { ModalLayout } from "../ModalLayout";
import { getFiles } from "../../api/files";

import { useOnlineStatus } from "../../hooks/useSync";
import { db } from "../../libraries/db";

export const ComentariosElementos = ({
  idTarea,
  idElemento,
  idAnalisis,
  nombreAnalisis,
}) => {
  const [comentarios, setComentarios] = useState([]);
  const [comentarioEscrito, setComentarioEscrito] = useState("");
  const [comentarioEditar, setComentarioEditar] = useState([]);
  const [comentarioEliminar, setComentarioEliminar] = useState([]);
  const [archivos, setArchivos] = useState([]);
  const [archivosTarea, setArchivosTarea] = useState([]);
  const [tareasAnalisis, setTareasAnalisis] = useState([]);

  const [openModal, setOpenModal] = useState(false);
  const [openModalEliminar, setOpenModalEliminar] = useState(false);

  const { user } = useContext(AuthContext);

  const isOnline = useOnlineStatus();

  useEffect(() => {
    getFiles().then((resp) =>
      setArchivos(
        resp.filter(
          (archivo) => archivo.idTareaAnalisis === idTarea && !archivo.deleted,
        ),
      ),
    );

    if (idTarea != undefined) {
      cargarComentarios();
    } else {
      cargarComentariosElemento();
    }
  }, [idTarea, idElemento]);

  const cargarComentarios = async () => {
    if (isOnline) {
      getComentariosByTareaId(idTarea).then((res) => {
        setComentarios(res);
      });
    } else {
      try {
        const local = await db.table("GES_ComentariosElementos").toArray();
        const filtered = local.filter((c) => {
          return (
            Number(c.idTarea) === Number(idTarea) &&
            (!c.deleted || c.deleted === false)
          );
        });

        setComentarios(filtered);
      } catch (err) {
        console.error("ERROR en cargarComentarios offline:", err); // <-- aquí puede estar el problema
      }
    }
  };

  const cargarComentariosElemento = async () => {
    if (isOnline) {
      getComentariosByElementoId(idElemento).then((res) => {
        setComentarios(res);
      });
    } else {
      const local = await db.table("GES_ComentariosElementos").toArray();
      const filtered = local.filter(
        (c) =>
          c.idElemento === idElemento && (!c.deleted || c.deleted === false),
      );
      setComentarios(filtered);
      console.log("Comentarios cargados desde IndexedDB:", filtered);
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleCloseModalEliminar = () => {
    setOpenModalEliminar(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (idElemento === 0) {
      return;
    }
    if (idTarea === 0) {
      return;
    }
    if (comentarioEscrito === "") {
      return;
    }

    if (idAnalisis === undefined || nombreAnalisis === undefined) {
      return;
    }

    const comentario = {
      idElemento: idElemento,
      idTarea: idTarea,
      comentario: comentarioEscrito,
      nombreUsuario: user.nombre,
      apellidosUsuario: user.apellidos,
      nombreAnalisis: nombreAnalisis,
      idAnalisis: idAnalisis,
    };

    if (isOnline) {
      await postComentario(comentario);
    } else {
      try {
        await db.transaction('rw', db.table("PendingSync"), db.table("GES_ComentariosElementos"), async () => {
          const pendingSyncId = await db.table("PendingSync").add({
            type: "POST_COMENTARIO",
            data: comentario,
            timestamp: Date.now(),
          });
          await db.table("GES_ComentariosElementos").add({
            ...comentario,
            fecha: new Date().toISOString(),
            _localOnly: true,
            _pendingSyncId: pendingSyncId,
          });
        });
      } catch (error) {
        console.error("Error al guardar comentario offline:", error);
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Error",
          text: "No se pudo guardar el comentario en modo offline",
          showConfirmButton: true,
        });
        return;
      }
    }
    setComentarioEscrito("");
    await cargarComentarios();
  };
  const handleChange = (event) => {
    setComentarioEscrito(event.target.value);
  };

  const handleChangeComentario = (e) => {
    const { name, value } = e.target;
    setComentarioEditar((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const editarComentario = async (id) => {
    setOpenModal(true);
    const resp = await getComentarioById(id);
    setComentarioEditar((prev) => ({ ...prev, ...resp }));
  };

  const eliminarComentario = async (id) => {
    setOpenModalEliminar(true);
    const resp = await getComentarioById(id);
    setComentarioEliminar((prev) => ({ ...prev, ...resp }));
  };

  const peticionPutComentario = async () => {
    if (isOnline) {
      await putComentario(comentarioEditar);
    } else {
      // Actualizar en IndexedDB (visible offline)
      await db
        .table("GES_ComentariosElementos")
        .update(comentarioEditar.Id ?? comentarioEditar.id, {
          comentario: comentarioEditar.comentario,
        });

      if (comentarioEditar._localOnly) {
        await db
          .table("PendingSync")
          .where("id")
          .equals(comentarioEditar._pendingSyncId)
          .modify((item) => {
            item.data.comentario = comentarioEditar.comentario;
          });
      } else {
        // Ya existe en servidor: encolar PUT
        await db.table("PendingSync").add({
          type: "PUT_COMENTARIO",
          data: comentarioEditar,
          timestamp: Date.now(),
        });
      }
    }
    await cargarComentarios();

    Swal.fire({
      position: "center",
      icon: "info",
      title: "Comentario Modificado",
      text: `El comentario se ha modificado correctamente`,
      showConfirmButton: false,
      timer: 2000,
      showClass: {
        popup: "animate__animated animate__bounceIn",
      },
      hideClass: {
        popup: "animate__animated animate__bounceOut",
      },
    });
  };

  const peticionDeleteComentario = async () => {
    if (isOnline) {
      await deleteComentario(comentarioEliminar.id);
    } else {
      await db.transaction('rw', db.table("PendingSync"), db.table("GES_ComentariosElementos"), async () => {
        if (comentarioEliminar._localOnly) {
          await db.table("GES_ComentariosElementos").delete(comentarioEliminar.Id ?? comentarioEliminar.id);
          await db.table("PendingSync").delete(comentarioEliminar._pendingSyncId);
        } else {
          await db.table("GES_ComentariosElementos").update(comentarioEliminar.Id ?? comentarioEliminar.id, { deleted: true });
          await db.table("PendingSync").add({
            type: "DELETE_COMENTARIO",
            data: { id: comentarioEliminar.id },
            timestamp: Date.now(),
          });
        }
      });
    }
    await cargarComentarios();
    handleCloseModalEliminar();

    Swal.fire({
      position: "center",
      icon: "info",
      title: "Comentario Eliminado",
      text: `El comentario se ha eliminado correctamente`,
      showConfirmButton: false,
      timer: 2000,
      showClass: {
        popup: "animate__animated animate__bounceIn",
      },
      hideClass: {
        popup: "animate__animated animate__bounceOut",
      },
    });
  };

  return (
    <>
      <div>
        <p>Comentarios Informes Fisico-Químico</p>
        <div className="comentarios-elementos-contenedor">
          <div className="comentario-escrito2">
            {comentarios.length > archivos.length ? (
              <form onSubmit={handleSubmit}>
                <input
                  disabled
                  type="text"
                  className="observacion-escrita2"
                  value={comentarioEscrito}
                  onChange={handleChange}
                  placeholder="Introduzca comentario + Enter"
                ></input>
              </form>
            ) : (
              <form onSubmit={handleSubmit}>
                <input
                  type="text"
                  className="observacion-escrita2"
                  value={comentarioEscrito}
                  onChange={handleChange}
                  placeholder="Introduzca comentario + Enter"
                ></input>
              </form>
            )}
          </div>
          {comentarios.map((comentario) => {
            let fechaMostrar = new Date(comentario.fecha);
            let fechaString = fechaMostrar.toLocaleDateString();
            const nombreArchivo = archivos.find(
              (archivo) => archivo.idComentario === comentario.id,
            );

            // Validación robusta
            const esAutor =
              user.nombre === comentario.nombreUsuario &&
              user.apellidos === comentario.apellidosUsuario;
            const esAdmin = user.idPerfil === 1005;
            const puedeEditar = esAutor || esAdmin;

            return (
              <div key={comentario.id}>
                <h4>
                  {`${comentario.nombreUsuario} ${comentario.apellidosUsuario} ${fechaString} ${comentario.nombreAnalisis} - ${nombreArchivo ? nombreArchivo.name : ""}`}

                  {puedeEditar && (
                    <>
                      <EditIcon
                        style={{ cursor: "pointer", marginLeft: "5px" }}
                        onClick={() => {
                          setComentarioEditar(comentario); // Cargamos el comentario directamente
                          setOpenModal(true);
                        }}
                      />
                      <DeleteIcon
                        style={{ cursor: "pointer", marginLeft: "5px" }}
                        onClick={() => {
                          setComentarioEliminar(comentario);
                          setOpenModalEliminar(true);
                        }}
                      />
                    </>
                  )}
                </h4>
                <p>{comentario.comentario}</p>
              </div>
            );
          })}
        </div>
      </div>

      <ModalLayout
        titulo="Editar Comentario"
        contenido={
          <Grid item xs={12}>
            <Grid container sx={{ textAlign: "center", pb: 2 }}>
              <Grid item xs={12}>
                <TextField
                  sx={{ width: "100%" }}
                  name="comentario"
                  value={comentarioEditar && comentarioEditar.comentario}
                  onChange={handleChangeComentario}
                />
              </Grid>
            </Grid>
          </Grid>
        }
        botones={[
          insertarBotonesModal(<AddIcon />, "Guardar", async () => {
            peticionPutComentario();
          }),
        ]}
        open={openModal}
        onClose={handleCloseModal}
      />

      <ModalLayout
        titulo="Eliminar Comentario"
        contenido={
          <>
            <Grid item xs={12}>
              <Typography>
                Estás seguro que deseas eliminar este comentario?
              </Typography>
            </Grid>
          </>
        }
        botones={[
          insertarBotonesModal(
            <DeleteIcon />,
            "Eliminar",
            async () => {
              peticionDeleteComentario();
            },
            "error",
          ),
        ]}
        open={openModalEliminar}
        onClose={handleCloseModalEliminar}
      />
    </>
  );
};
